export enum SearchTableType {
    Inventory = 100,
    Dispatch = 200,
    Orders = 300,
    QuoteTemplate = 400,
    VendorCredits = 500,
    VendorReturns = 600,
    Invoices = 700,
    Quotes = 800,
    Vehicles = 900,
    Supplier = 1000,
    AssetsTracking = 1100,
    AssetWarehouse = 1200,
    BillingCode = 1500,
    Employees = 1600,
    InventoryLocation = 1700,
}
